<template>
  <div>
            <v-fab-transition>
    <v-btn icon large slot="activator" v-if="this.$store.getters.gemerktzahl" :to="{ name: 'gemerkt' }">
      <v-badge right color="grey lighten-3" overlap>
        <span slot="badge" color="black" style="color: black;">
          {{ this.$store.getters.gemerktzahl }}
        </span>
        <v-icon color="accent" large>favorite</v-icon>
      </v-badge>
    </v-btn>
            </v-fab-transition>
  </div>
</template>

<script>

export default {

  components: {

  },
  data: () => ({

  }),
  computed: {

  },
  mounted: function () {
  },

  methods: {

  }
}
</script>
<style>
</style>